import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

// Auth
import LoginPage from './pages/LoginPage'

// Dashboards
import ResultDashboardPage from './pages/ResultDashboardPage'
import TeacherDashboardPage from './pages/TeacherDashboardPage'

// Result workflow
import PrintResultsPage from './pages/PrintResultsPage'
import ExamManagerPage from './pages/ExamManagerPage'
import ExamPanelPage from './pages/ExamPanelPage'
import SubjectRulesPage from './pages/SubjectRulesPage'
import TeacherGradeEntryPage from './pages/TeacherGradeEntryPage'
import SubjectGpaPage from './pages/SubjectGpaPage'
import GpaFinalPage from './pages/GpaFinalPage'
import ResultListPage from './pages/ResultListPage'
import FailReportPage from './pages/FailReportPage'

// Grade entry
import GradeEntrySystemPage from './pages/GradeEntrySystemPage'
import GradeEntry2Page from './pages/GradeEntry2Page'
import GradeManagementPage from './pages/GradeManagementPage'

// Student pages
import StudentDetailsPage from './pages/StudentDetailsPageNew'
import StudentDetailsAccessPage from './pages/StudentDetailsAccessPage'
import StudentManagementPage from './pages/StudentManagementPage'
import DataListPage from './pages/DataListPage'
import DataListSubjectPage from './pages/DataListSubjectPage'
import DetailsResultPage from './pages/DetailsResultPage'
import AddStudentPage from './pages/AddStudentPage'
import TestimonialPage from './pages/TestimonialPage'
import VerifyTestimonialPage from './pages/VerifyTestimonialPage'

// Setup / admin
import SetupPage from './pages/SetupPage'
import SubjectSetupPage from './pages/SubjectSetupPage'
import SubjectTeacherPage from './pages/SubjectTeacherPage'
import ClassSubjectPage from './pages/ClassSubjectPage'
import TeacherSetupPage from './pages/TeacherSetupPage'
import TeacherAccessListPage from './pages/TeacherAccessListPage'
import ResultEntryPage from './pages/ResultEntryPage'
import ResultEntryAdminPage from './pages/ResultEntryAdminPage'
import ResultTableColmAddPage from './pages/ResultTableColmAddPage'
import SessionSubjectPage from './pages/SessionSubjectPage'
import TeacherManagementPage from './pages/TeacherManagementPage'

// Reports
import SmsFullPage from './pages/SmsFullPage'
import SummaryPage from './pages/SummaryPage'

// Web Admin
import WebAdminPage from './pages/WebAdminPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Auth */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login-teacher" element={<Navigate to="/login" replace />} />

        {/* Dashboards */}
        <Route path="/dashboard" element={<ResultDashboardPage />} />
        <Route path="/teacher-dashboard" element={<TeacherDashboardPage />} />

        {/* Result workflow */}
        <Route path="/print-results/:examId?" element={<PrintResultsPage />} />
        <Route path="/exam-control" element={<ExamManagerPage />} />
        <Route path="/exam-manager" element={<ExamManagerPage />} />
        <Route path="/subject-gpa/:examId?" element={<SubjectGpaPage />} />
        <Route path="/gpa-final/:examId?" element={<GpaFinalPage />} />
        <Route path="/exam-panel/:id" element={<ExamPanelPage />} />
        <Route path="/exam-subjects/:id" element={<SubjectRulesPage />} />
        <Route path="/exam-teachers/:id" element={<TeacherSetupPage />} />
        <Route path="/teacher-entry/:examId/:assignId" element={<TeacherGradeEntryPage />} />
        <Route path="/result-list/:examId?" element={<ResultListPage />} />
        <Route path="/fail-report/:examId?" element={<FailReportPage />} />

        {/* Grade entry */}
        <Route path="/grade-entry" element={<GradeEntrySystemPage />} />
        <Route path="/grade-entry-2" element={<GradeEntry2Page />} />
        <Route path="/grade-management" element={<GradeManagementPage />} />

        {/* Student pages */}
        <Route path="/student-details" element={<StudentDetailsPage />} />
        <Route path="/student-details-access" element={<StudentDetailsAccessPage />} />
        <Route path="/students" element={<StudentManagementPage />} />
        <Route path="/add-student" element={<AddStudentPage />} />
        <Route path="/addstudent" element={<AddStudentPage />} />
        <Route path="/addstudent.html" element={<AddStudentPage />} />
        <Route path="/testimonial" element={<TestimonialPage />} />
        <Route path="/testimonial.html" element={<TestimonialPage />} />
        <Route path="/verify-testimonial" element={<VerifyTestimonialPage />} />
        <Route path="/datalist" element={<DataListPage />} />
        <Route path="/datalist_2025" element={<DataListPage />} />
        <Route path="/datalist-subject" element={<DataListSubjectPage />} />
        <Route path="/datalist_subject" element={<DataListSubjectPage />} />
        <Route path="/datalist_subject.html" element={<DataListSubjectPage />} />
        <Route path="/details-result" element={<DetailsResultPage />} />

        {/* Setup / admin */}
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/setup.html" element={<SetupPage />} />
        <Route path="/college-setup" element={<SetupPage />} />
        <Route path="/subject-setup" element={<SubjectSetupPage />} />
        <Route path="/session-subject" element={<SessionSubjectPage />} />
        <Route path="/session-subjects" element={<SessionSubjectPage />} />
        <Route path="/teachers-database" element={<TeacherManagementPage />} />
        <Route path="/teachers-management" element={<TeacherManagementPage />} />
        <Route path="/subject-teacher" element={<SubjectTeacherPage />} />
        <Route path="/class-subject" element={<ClassSubjectPage />} />
        <Route path="/teacher-setup/:id?" element={<TeacherSetupPage />} />
        <Route path="/teacher_access_list/:examId?" element={<TeacherAccessListPage />} />
        <Route path="/teacher-access-list/:examId?" element={<TeacherAccessListPage />} />
        <Route path="/result-entry" element={<ResultEntryPage />} />
        <Route path="/result-entry-admin" element={<ResultEntryAdminPage />} />
        <Route path="/result-table" element={<ResultTableColmAddPage />} />

        {/* Reports */}
        <Route path="/sms-full/:examId?" element={<SmsFullPage />} />
        <Route path="/summary" element={<SummaryPage />} />

        {/* Web Admin */}
        <Route path="/web_admin" element={<WebAdminPage />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

